import { Actions as EMPLOYEEACTIONS } from "@/redux/actions/employeeActions";
import { Actions as LEAVEACTIONS } from "@/redux/actions/leaveActions";
import {
	CheckBadgeIcon,
	ChevronDoubleLeftIcon,
	ChevronDoubleRightIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
	ClipboardDocumentListIcon,
	XMarkIcon,
} from "@heroicons/react/20/solid";
import { DateInputFormat } from "@/common/DateComponents";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

import ListView, { Row } from "@/common/custom-lists/ListView";
import { format } from "date-fns";
import _ from "lodash";
import DatePicker from "react-datepicker";
import Select from "react-select";
import Modal from "@/common/Modal";

const MarkLeaveModal = ({
	org,
	isAdmin,
	employeesGetList,
	markLeave,
	employeeOptions,
	employees,
	markOptions,
	markedLeave,
	clearMarkedLeave,
	leaveTypes,
	isOpen,
	closeModal,
}) => {
	const [view, setView] = useState("mark");

	const [from, setFrom] = useState(new Date());
	const [to, setTo] = useState(new Date());
	const [employee, setEmployee] = useState({ value: "all", label: "All Employees" });
	const [markAs, setMarkAs] = useState({ value: "paid", label: "Paid" });

	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [page, setPage] = useState(0);
	const start = page * itemsPerPage;
	const end = (page + 1) * itemsPerPage;
	const lastPage = Math.ceil(markedLeave?.length / itemsPerPage);

	const Pagination = () => {
		if (markedLeave?.length <= 0) return null;
		return (
			<thead>
				<tr>
					<th
						colSpan={7}
						className="p-3"
					>
						<div
							style={{
								display: "grid",
								gridGap: "1.5rem",
								grid: "1.5rem",
								gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
							}}
						>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go To Page 1"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(0);
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 5 Pages"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(Math.max(page - 5, 0));
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 1 Page"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(page - 1);
									}}
									disabled={page === 0}
								>
									<ChevronLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<strong>
									Page {page + 1}/{lastPage}
								</strong>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title={`Go to Page ${lastPage}`}
									onClick={() => {
										if (page !== lastPage - 1) setPage(lastPage - 1);
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title="Go Forward 5 Pages"
									onClick={() => {
										if (page !== lastPage - 1) setPage(Math.min(page + 5, lastPage - 1));
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									title="Go Forward 1 Page"
									style={{ marginRight: "0.5rem" }}
									onClick={() => {
										if (page !== lastPage - 1) setPage(page + 1);
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
						</div>
					</th>
				</tr>
			</thead>
		);
	};

	const mark = () => {
		markLeave({
			markAs: markAs.value,
			from: format(from, "yyyy-MM-dd"),
			to: format(to, "yyyy-MM-dd"),
			employee: employee.value,
		});
	};

	//Restore to defaults when modal is opened
	useEffect(() => {
		if (!isOpen) return;

		setView("mark");
		clearMarkedLeave();
		setPage(0);
	}, [isOpen]);

	useEffect(() => {
		employeesGetList();
	}, [org]);

	useEffect(() => {
		if (markedLeave?.length > 0) return setView("overview");
		setView("mark");
	}, [markedLeave]);

	//Return if user is not admin
	if (!isAdmin) return null;

	return (
		<Modal
			status={isOpen}
			close={() => closeModal()}
			width="50%"
			title="Mark Leave"
		>
			<div
				className="block-content"
				style={{ display: view == "mark" ? "block" : "none" }}
			>
				<div className="col-xs-12 p-0 pb-5">
					<div className="col-xs-6">
						<label>From</label>
						<DatePicker
							wrapperClassName="full-width"
							selected={from}
							onChange={(date) => setFrom(date)}
							dateFormat="dd/MM/yyy"
							popperPlacement="bottom-start"
							customInput={<DateInputFormat />}
							maxDate={to}
						/>
					</div>
					<div className="col-xs-6">
						<label>To</label>
						<DatePicker
							wrapperClassName="full-width"
							selected={to}
							onChange={(date) => setTo(date)}
							dateFormat="dd/MM/yyy"
							popperPlacement="bottom-start"
							customInput={<DateInputFormat />}
							minDate={from}
						/>
					</div>
				</div>
				<div className="col-xs-12 p-0 pb-24">
					<div className="col-xs-6">
						<label>Employee</label>
						<Select
							options={employeeOptions}
							onChange={(e) => setEmployee(e)}
							value={employeeOptions?.find((e) => e.value === employee.value)}
						/>
					</div>
					<div className="col-xs-6">
						<label>Mark As</label>
						<Select
							options={markOptions}
							onChange={(e) => setMarkAs(e)}
							value={markOptions?.find((e) => e.value === markAs.value)}
						/>
					</div>
				</div>

				<div className="col-xs-12 pb-5">
					<div
						className="btn btn-success pull-right"
						onClick={mark}
					>
						<CheckBadgeIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<span style={{ float: "left" }}>Mark</span>
					</div>
					<div
						className="btn btn-danger pull-right"
						style={{ marginRight: 5 }}
						onClick={() => closeModal()}
					>
						Cancel
					</div>
				</div>
			</div>
			<div
				className="block-content"
				style={{
					display: view === "overview" ? "block" : "none",
				}}
			>
				<div
					className="col-sm-12"
					style={{ paddingBottom: 10, paddingLeft: 0, paddingRight: 0 }}
				>
					<div
						className="col-xs-12 mb-5"
						style={{
							fontSize: "1.3em",
							fontWeight: "550",
						}}
					>
						<div className="col-xs-12 p-0">
							<span className="pull-left">Period</span>
						</div>
						<div className="col-xs-12 p-0">
							<span
								className="pull-left"
								style={{ fontSize: "13px" }}
							>{`${format(from, "dd/MM/yyyy")} - ${format(to, "dd/MM/yyyy")}`}</span>
						</div>
						<div className="col-xs-12 p-0">
							<span
								className="pull-left"
								style={{ fontSize: "13px" }}
							>{`Leave marked as ${markAs?.value}`}</span>
						</div>
					</div>
					<div className="clearfix" />
					<div
						className="p-0"
						style={{ backgroundColor: "#ECEFF1", borderRadius: 10 }}
					>
						<div
							className="col-xs-12 p-4"
							style={{
								display: "flex",
								justifyContent: "center",
								backgroundColor: "#ECEFF1",
								borderRadius: 10,
							}}
						>
							<div
								className="col-xs-12 p-0"
								style={{
									display: "flex",
									justifyContent: "center",
									backgroundColor: "white",
									borderRadius: 10,
									boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
								}}
							>
								<Pagination />
							</div>
						</div>
						<div className="clearfix" />
						<ListView
							{...{
								title: "Marked Leave",
								items: markedLeave?.slice(start, end).map((leave) => {
									const employee = employees?.find((e) => e.id === leave.agreement);
									const fullName = `${employee?.employeeDetails.givenName} ${employee?.employeeDetails.familyName}`;
									const type = leaveTypes?.find((t) => t.id === leave.type)?.name;
									return (
										<Row
											actionColumns={[0]}
											columns={[" ", fullName, type, leave.date, " "]}
										/>
									);
								}),
								columns: [{ hidden: true }, "Employee", "Type", "Date", { hidden: true }],
							}}
						/>
					</div>
					<div
						className="btn btn-success pull-right"
						onClick={() => clearMarkedLeave()}
					>
						<CheckBadgeIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<span style={{ float: "left" }}>Continue</span>
					</div>
					<div
						className="btn btn-danger pull-right"
						style={{ marginRight: 5 }}
						onClick={() => closeModal()}
					>
						Close
					</div>
				</div>
			</div>
			<div className="clearfix" />
		</Modal>
	);
};

const mapStateToProps = (state) => {
	const employees = state?.employees?.employeeList;

	const employeeOptions = employees?.map((employee) => ({
		value: employee.id,
		label: `${employee.employeeDetails.givenName} ${employee.employeeDetails.familyName}`,
	}));

	employeeOptions?.unshift({
		value: "all",
		label: "All Employees",
	});

	const markOptions = [
		{
			value: "paid",
			label: "Paid",
		},
		{
			value: "unpaid",
			label: "Unpaid",
		},
	];

	const markedLeave = _.orderBy(state?.leave?.markedModal?.markedLeave, ["employee", "date"], ["desc", "asc"]);

	return {
		org: state?.company?.settings?.org,
		isAdmin: state?.my?.profile?.isAdmin,
		employeeOptions,
		employees,
		markOptions,
		markedLeave,
		leaveTypes: state.leave.leaveTypes,
		isOpen: state.leave?.markedModal?.open,
	};
};

const mapDispatchToProps = (dispatch) => ({
	employeesGetList: () => dispatch(EMPLOYEEACTIONS.employeesGetList()),
	markLeave: ({ markAs, from, to, employee }) => dispatch(LEAVEACTIONS.markLeave({ markAs, from, to, employee })),
	clearMarkedLeave: () => dispatch(LEAVEACTIONS.saveMarkedLeave([])),
	closeModal: () => dispatch(LEAVEACTIONS.setMarkedLeaveModal(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MarkLeaveModal);
